import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class PurchaseIncorrectNetValueWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.purchase.validation.incorrect-net-value-warning.message');
    }
}
